<template>
  <el-config-provider :locale="locale">
    <router-view v-slot="{ Component }" :key="routerKey">
      <component :is="Component" />
    </router-view>
  </el-config-provider>
  <transition name="el-fade-in-linear">
    <div class="loading-page" v-if="isPageLoading">
      <div class="content">
        <span style="font-size: 12px; color: rgba(0, 0, 0, 0.5)">
          {{ $t('main_login_get_in') }}
        </span>
        <el-progress
          ref="loadingProgress"
          style="margin-top: 10px"
          :percentage="percentage"
          :show-text="false"
        ></el-progress>
      </div>
    </div>
  </transition>
</template>

<script>
import { defineComponent, ref, onMounted, provide, nextTick } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
// import { prefetchApps } from 'qiankun'

import { getAuthentication, getEnvironmentConfig, getUserMenuList } from '@/services/user'

export default defineComponent({
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  setup() {
    const isPageLoading = ref(false)
    const isAuth = ref(false)

    const router = useRouter()
    const store = useStore()
    // 刷新路由key
    const routerKey = ref(Date.now())
    // 刷新
    const reloadView = () => {
      routerKey.value = Date.now()
    }
    provide('reloadView', reloadView)

    const toLogin = async data => {
      return new Promise((resolve, reject) => {
        const userInfo = {
          name: data.info.meta.Name,
          uid: data.info.uid,
          token: data.token,
          expired: data.expired
        }
        store.commit('menu/resetTab')
        store.commit('user/setUserInfo', userInfo)

        getUserMenuList()
          .then(res => {
            store.commit('menu/setMenuList', res.data.menuList)
            store.commit('menu/setPageList', res.data.pageList)
            resolve()
          })
          .catch(error => {
            store.commit('user/setUserInfo', null)
            reject(error)
          })
      })
    }
    const getEnv = async () => {
      return new Promise((resolve, reject) => {
        getEnvironmentConfig()
          .then(res => {
            store.commit('env/setEnv', res?.data?.EnvironmentName?.toLowerCase())
            store.commit('baseUrl/setBaseUrl', res?.data?.GatewayEntrypoint)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }

    const getAuth = async () => {
      const query = window.location.search.substring(1).split('&')
      const vars = {}
      query.forEach(item => {
        const objArr = item.split('=')
        vars[objArr[0]] = objArr[1]
      })
      let token = ''
      if (vars.jumpType === 'SYS' && vars.token) {
        token = vars.token
      } else {
        token = store.state.user?.userInfo?.token
      }
      if (token) {
        try {
          isPageLoading.value = true
          const { data } = await getAuthentication(token)
          if (vars.jumpType === 'SYS' && vars.token) {
            if (!store.state.env.env) {
              await getEnv()
            }
            await toLogin(data)
          }
        } catch (error) {
          console.log(error)
          store.commit('user/redirectLogin')
        } finally {
          if (vars.jumpType === 'SYS' && vars.token) {
            // 如果是第三方跳转的，需要重写路径
            router.replace(window.location.pathname)
          }
          percentage.value = 100
          isAuth.value = true
        }
      }
    }
    getAuth()

    const percentage = ref(0)
    const progressTimer = setInterval(() => {
      if (percentage.value === 100) {
        clearInterval(progressTimer)
        return
      }
      percentage.value += 5
    }, 200)

    const loadingProgress = ref(null)

    onMounted(() => {
      if (loadingProgress.value) {
        const progressDom = loadingProgress.value.$el.querySelector('.el-progress-bar__inner')
        const handle = () => {
          if (isAuth.value) {
            nextTick(() => {
              isPageLoading.value = false
              progressDom.removeEventListener('transitionend', handle)
            })
          }
        }
        progressDom.addEventListener('transitionend', handle, false)
      }
    })

    // process.env.NODE_ENV !== 'development' && prefetchApps(store.state.microApp.microApps)

    return {
      locale: zhCn,
      percentage,
      isPageLoading,
      loadingProgress,
      routerKey
    }
  }
})
</script>

<style lang="scss">
#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.hide-menu-popover {
  .hide-menu-item {
    cursor: pointer;
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &:hover {
      color: $primary-color;
    }

    &.is-active {
      color: $primary-color;
    }
  }
}

.loading-page {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #ffffff;
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    width: 300px;
    text-align: center;

    .el-progress-bar__innerText span {
      margin-left: 10px;
    }
  }
}
</style>
